<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-text.pa-6
      div.text-xl.font-medium.neutral700--text Which loyalty system you would like to use?
      div.mt-4(:style="system === 'stamps' ? activeStyle : inactiveStyle" @click="system = 'stamps'")
        v-row(align="center")
          v-col(cols="1" align="center")
            v-icon(v-if="system === 'stamps'"  size="22" color="neutral700") mdi-radiobox-marked
            v-icon(v-else size="22" color="neutral500") mdi-radiobox-blank
          v-col.shrink(align="center")
            v-img(:src="require('@/assets/images/loyalty_stamp.png')" width="120")
          v-col
            div.text-md.font-semibold.neutral700--text Stamp loyalty system
            div.text-sm.neutral700--text.mt-1 Collect stamps and decide the rewards to give to your customer once they’ve achieved certain progress!
      div.mt-4(:style="system === 'points' ? activeStyle : inactiveStyle" @click="system = 'points'")
        v-row(align="center")
          v-col(cols="1" align="center")
            v-icon(v-if="system === 'points'"  size="22" color="neutral700") mdi-radiobox-marked
            v-icon(v-else size="22" color="neutral500") mdi-radiobox-blank
          v-col.shrink(align="center")
            v-img(:src="require('@/assets/images/loyalty_point.png')" width="113")
          v-col
            div.text-md.font-semibold.neutral700--text Points loyalty system
            div.text-sm.neutral700--text.mt-1 Collect points and decide the rewards to give to your customer once they’ve achieved certain points amount!
        
    v-divider
    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Select" size="md" :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    loyaltySystem: {
      type: String,
      default: 'stamps'
    },
  },
  data () {
    return {
      isLoading: false,
      system: 'stamps',
      activeStyle: {
        border: '2px solid var(--v-neutral700)',
        borderRadius: '10px',
        padding: '16px',
        cursor: 'pointer'
      },
      inactiveStyle: {
        border: '1px solid var(--v-neutral400)',
        borderRadius: '10px',
        padding: '17px',
        cursor: 'pointer'
      }
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.system = this.loyaltySystem
  },
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      this.$emit('update:loyaltySystem', this.system)
      this.closeDialog()
    },
    closeDialog () {
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
</style>